{
  "name": "frontend",
  "version": "1.3.66",
  "engines": {
    "node": ">=22 <23"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --configuration=production",
    "build:dev": "ng build --configuration=development",
    "build:staging": "ng build --configuration=staging",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "prepare": "husky",
    "release:patch": "standard-version --release-as patch --releaseCommitMessageFormat 'chore(release): {{currentTag}}'",
    "release:minor": "standard-version --release-as minor --releaseCommitMessageFormat 'chore(release): {{currentTag}}'",
    "release:major": "standard-version --release-as major --releaseCommitMessageFormat 'chore(release): {{currentTag}}'"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.0.2",
    "@angular/cdk": "^20.0.2",
    "@angular/common": "^20.0.2",
    "@angular/compiler": "^20.0.2",
    "@angular/core": "^20.0.2",
    "@angular/forms": "^20.0.2",
    "@angular/material": "^20.0.2",
    "@angular/platform-browser": "^20.0.2",
    "@angular/platform-browser-dynamic": "^20.0.2",
    "@angular/router": "^20.0.2",
    "@datadog/browser-rum": "^7.15.0",
    "@datadog/browser-rum-angular": "^7.15.0",
    "@fortawesome/angular-fontawesome": "^3.0.0",
    "@fortawesome/fontawesome-svg-core": "^7.3.1",
    "@fortawesome/pro-light-svg-icons": "^7.3.1",
    "@tailwindcss/postcss": "^4.0.14",
    "@tanstack/angular-table": "^8.21.4",
    "@types/handlebars": "^4.0.40",
    "aws-amplify": "^6.13.5",
    "buffer": "^6.0.3",
    "echarts": "^6.1.0",
    "exceljs": "4.4.0",
    "handlebars": "^4.7.8",
    "html2canvas": "^1.4.1",
    "jspdf": "^3.0.1",
    "jszip": "^3.10.1",
    "launchdarkly-js-client-sdk": "^3.7.0",
    "launchdarkly-node-client-sdk": "^3.3.0",
    "pdfkit": "^0.17.1",
    "pdfmake": "^0.2.20",
    "postcss": "^8.5.3",
    "posthog-js": "^1.386.6",
    "process": "^0.11.10",
    "qrcode": "^1.5.4",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.0.14",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/custom-webpack": "^20.0.0",
    "@angular/build": "^20.3.6",
    "@angular/cli": "^20.0.1",
    "@angular/compiler-cli": "^20.0.2",
    "@commitlint/cli": "^20.4.2",
    "@commitlint/config-conventional": "^20.4.2",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.15.19",
    "@types/pdfmake": "^0.2.12",
    "@types/qrcode": "^1.5.6",
    "husky": "^9.1.7",
    "jasmine-core": "~5.5.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.5.3",
    "standard-version": "^9.5.0",
    "typescript": "~5.8.3"
  }
}
